import { get, size } from './immutable';

function selectChildrenWithoutPath(jPath, pPath, opt, i, fromId) {
  const currentPath = [...pPath, i];
  const currentPathJoined = currentPath.join();
  const children = get(opt, 'children');
  if (size(children)) {
    return children.reduce(
      (arr, child, j) =>
        arr.concat(
          selectChildrenWithoutPath(
            jPath,
            currentPath,
            child,
            fromId ? child.id : j,
            fromId
          )
        ),
      []
    );
  } else if (
    currentPathJoined !== jPath &&
    currentPathJoined.indexOf(`${jPath},`) === -1
  ) {
    return [currentPath];
  }
  return [];
}

export function updateMultipleSelection(
  selectedPaths,
  path,
  select,
  options,
  fromId = false
) {
  const joinedPath = path.join();
  let newSelection = selectedPaths;
  if (select && !selectedPaths.some((p) => p.join() === joinedPath)) {
    // add path to selection
    newSelection = [...selectedPaths, path];
  } else if (!select) {
    // remove path from selection
    const parentPath = selectedPaths.reduce((prevPath, curPath) => {
      if (prevPath.join().indexOf(`${curPath.join()},`) === 0) {
        return curPath;
      }
      return prevPath;
    }, path);
    // if no selected parent found parentPath = path
    const joinedParentPath = parentPath.join();
    newSelection = selectedPaths.filter((p) => {
      const pJoined = p.join();
      return !(
        pJoined === joinedParentPath ||
        pJoined.indexOf(`${joinedParentPath},`) === 0
      );
    });
    if (joinedParentPath !== joinedPath) {
      // if selected parent found: select all children except path
      const parentOpt = parentPath.reduce((opt, p, i) => {
        const item = fromId
          ? opt.find((e) => Number(e.id) === Number(p))
          : get(opt, p);
        const children = get(item, 'children');
        if (size(children) && i < parentPath.length - 1) {
          return children;
        }
        return item;
      }, options);
      newSelection = newSelection.concat(
        get(parentOpt, 'children', []).reduce(
          (arr, opt, i) =>
            arr.concat(
              selectChildrenWithoutPath(
                joinedPath,
                parentPath,
                opt,
                fromId ? opt.id : i,
                fromId
              )
            ),
          []
        )
      );
    }
  }
  return newSelection;
}
